import { render, staticRenderFns } from "./ShopTimescardUse.vue?vue&type=template&id=0970b12d&scoped=true"
import script from "./ShopTimescardUse.vue?vue&type=script&lang=js"
export * from "./ShopTimescardUse.vue?vue&type=script&lang=js"
import style0 from "./ShopTimescardUse.vue?vue&type=style&index=0&id=0970b12d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970b12d",
  null
  
)

export default component.exports